<template>
    <div
        class="pos-relative cursor-pointer overflow-hidden border-radius"
        @click="$emit('show-zoom')"
    >
        <div class="aspect pos-relative bg-default-1 iframe-inicial">
            <iframe
                class="lazy lazy-fade"
                :data-src="videoURL"
                ref="zoomImage"
                frameborder="0"
                style="position: absolute; top: 0px; left: 0px; width: 100%; height: 100%"
                allow="autoplay; fullscreen; picture-in-picture"
            ></iframe>
        </div>
    </div>
</template>

<script>
    import { updateLazyLoad } from '../../../common/lazyload';

    export default {
        name: 'SizeGuideVideoV2',

        components: {},

        props: {
            model: {
                type: Object,
                required: true,
            },
            video: {
                type: Object,
                required: true,
            },
        },

        data() {
            return {};
        },

        mounted() {
            this.$nextTick(() => {
                updateLazyLoad();
            });
        },

        computed: {
            videoURL() {
                let url = new URL(this.video.url);
                url.searchParams.set('background', 1);
                return url.toString();
            },
        },
    };
</script>
